import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { Award, ChevronLeft, Loader2, Search } from "lucide-react";
import { API } from "@/constants";
import Disclaimer from "@/components/shared/Disclaimer";
import Footer from "@/components/shared/Footer";

const ExpertNetworkPage = () => {
  const [experts, setExperts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [category, setCategory] = useState("");
  
  const EXPERT_CATEGORIES = [
    { value: "medical", label: "Medical" },
    { value: "engineering", label: "Engineering" },
    { value: "financial", label: "Financial" },
    { value: "forensic", label: "Forensic" },
    { value: "technical", label: "Technical" },
    { value: "psychological", label: "Psychological" },
    { value: "accident_reconstruction", label: "Accident Reconstruction" },
    { value: "economics", label: "Economics" }
  ];
  
  const search = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (category) params.append('category', category);
      const res = await axios.get(`${API}/services/experts/search?${params}`);
      setExperts(res.data.experts || []);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <main className="min-h-screen bg-slate-50" data-testid="expert-network-page">
      <Disclaimer />
      <div className="container-shell py-8 max-w-6xl">
        <div className="mb-6">
          <Link to="/tools/services-hub" className="text-sm text-muted-foreground hover:text-foreground flex items-center gap-1 mb-4">
            <ChevronLeft className="h-4 w-4" /> Back to Services Hub
          </Link>
          <h1 className="text-3xl font-bold mb-2" style={{ fontFamily: "'Fraunces', serif" }}>Expert Witness Network</h1>
          <p className="text-muted-foreground">Court experts across all specialties nationwide</p>
        </div>
        
        <Card className="mb-6">
          <CardContent className="p-6">
            <div className="grid md:grid-cols-3 gap-4">
              <div>
                <Label>Category</Label>
                <Select value={category} onValueChange={setCategory}>
                  <SelectTrigger><SelectValue placeholder="Select category" /></SelectTrigger>
                  <SelectContent>
                    {EXPERT_CATEGORIES.map(c => <SelectItem key={c.value} value={c.value}>{c.label}</SelectItem>)}
                  </SelectContent>
                </Select>
              </div>
              <div className="md:col-span-2 flex items-end">
                <Button onClick={search} disabled={loading} className="w-full">
                  {loading ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <Search className="h-4 w-4 mr-2" />}
                  Search Experts
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
        
        {experts.length === 0 && !loading && (
          <Card>
            <CardContent className="p-12 text-center">
              <Award className="h-12 w-12 mx-auto text-muted-foreground mb-4" />
              <p className="text-muted-foreground mb-4">Search for expert witnesses or submit a request</p>
              <Button>Request an Expert</Button>
            </CardContent>
          </Card>
        )}
      </div>
      <Footer />
    </main>
  );
};


export default ExpertNetworkPage;
